var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRechargeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83325 21.25V12.75C2.83325 10.4957 3.72879 8.33365 5.32284 6.73959C6.9169 5.14553 9.07891 4.25 11.3333 4.25H22.6666C24.9209 4.25 27.0829 5.14553 28.677 6.73959C30.2711 8.33365 31.1666 10.4957 31.1666 12.75V21.25C31.1666 23.5043 30.2711 25.6663 28.677 27.2604C27.0829 28.8545 24.9209 29.75 22.6666 29.75H11.3333C9.07891 29.75 6.9169 28.8545 5.32284 27.2604C3.72879 25.6663 2.83325 23.5043 2.83325 21.25Z",
    fill: "#3282FF",
    fillOpacity: 0.06,
    stroke: "#3282FF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5281 11.3334L14.1665 17H19.8332L17.4716 22.6667",
    stroke: "#3282FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRechargeIcon);
export default __webpack_public_path__ + "static/media/rechargeIcon.eb4b3efefe7194d07ff38b0b3de90ff2.svg";
export { ForwardRef as ReactComponent };